import { Button } from "@mui/material";
import { Stack } from "@mui/system";
import { SelectedAge } from "../../../models/SelectedAge";
import { useTranslation } from "react-i18next";
import './componentsStyle.css';
import CustomAgeComponent from "./customAgeComponent";
import { DropDownItem } from "../../../models/DropDownItem";
import DepartmentCustomAgeComponent from "./departmentCustomAgeComponent";
  
  export enum OtherAgeElementType{
    none,
    customElement,
    dropDownList
  }
  export type Props = {
    selectedAge:SelectedAge,
    customAgeElement:OtherAgeElementType,
    customSelectedAge:number,
    onSetCustomAge?:(age:number)=>void;
    onSetSelection:(selection:SelectedAge)=>void;
    OtherAgesList?:DropDownItem[]
    onSetDepartmentCustomAge?:(selection:DropDownItem)=>void
    minAgeIs35?: boolean;
    presetAge?: SelectedAge;
  }
const AgeFilterComponent:React.FC<Props> = ({
  selectedAge,
  customAgeElement,
  customSelectedAge,
  onSetSelection,
  onSetCustomAge,
  OtherAgesList,
  onSetDepartmentCustomAge,
  minAgeIs35,
  presetAge
}) => {
    const { t } = useTranslation();
    const isMinAge = (minAgeIs35 && selectedAge === SelectedAge.thirtyFive) || selectedAge===SelectedAge.birth;
    return(
      <div className="filter-type-container">
        <label id="label-filtre-age">{ t("filter_label_age") }</label>
        <Stack className='stack' spacing={1} direction="row">
          <Button 
            style={ { width:"166px" } } 
            variant={ isMinAge ? "contained" : "outlined" } 
            aria-pressed={ isMinAge ? true : false }
            aria-describedby="label-filtre-age"
            size='small'
            onClick={ () => {
              onSetSelection(minAgeIs35 ? SelectedAge.thirtyFive : SelectedAge.birth);
            }}
          >
            {t(`filter_button_age_${minAgeIs35 ? "35" : "birth"}`)}
          </Button>
          <Button
            style={ { width:"126px" } }
            variant={ selectedAge === SelectedAge.sixtyFive ? "contained" : "outlined" } 
            aria-pressed={ selectedAge === SelectedAge.sixtyFive ? true : false }
            aria-describedby="label-filtre-age"
            size='small'
            onClick={()=>{
              onSetSelection(SelectedAge.sixtyFive);
            }}
          >
            {t("filter_button_age_65")}
          </Button>
        </Stack>
        {(customAgeElement===OtherAgeElementType.customElement && onSetCustomAge) &&
          <CustomAgeComponent 
            customSelectedAge={customSelectedAge}
            onSetCustomAge={onSetCustomAge}
            presetAge={presetAge}
          ></CustomAgeComponent>
        }
        {(customAgeElement===OtherAgeElementType.dropDownList && OtherAgesList && onSetDepartmentCustomAge) &&
          <DepartmentCustomAgeComponent 
            differentAges={OtherAgesList}
            onChangeSelection={onSetDepartmentCustomAge}
          ></DepartmentCustomAgeComponent>
        }
    </div>)
}

export default AgeFilterComponent;